import type { Urgency } from '@/types/domain';
import type { IconName } from '@/shared/icon/icons';

export interface UrgencyMeta {
  value: Urgency;
  label: string;
  icon: IconName | null;
  /** css-модификатор для .urg-line/.urg-chip/.urg-ico (urgent/high/medium/low/none) */
  cls: string;
}

// §6.2 брифа: 4 уровня + none. Форма иконки — 3-й канал помимо цвета (AA).
export const URGENCY_META: Record<Urgency, UrgencyMeta> = {
  urgent: { value: 'urgent', label: 'Горящая', icon: 'flame', cls: 'urgent' },
  high: { value: 'high', label: 'Высокая', icon: 'chevrons-up', cls: 'high' },
  medium: { value: 'medium', label: 'Средняя', icon: 'equal', cls: 'medium' },
  low: { value: 'low', label: 'Низкая', icon: 'chevron-down', cls: 'low' },
  none: { value: 'none', label: 'Без срочности', icon: null, cls: 'none' },
};

/** Выбор срочности (для пикеров): по убыванию, none — отдельно/в конце. */
export const URGENCY_CHOICES: UrgencyMeta[] = [
  URGENCY_META.urgent,
  URGENCY_META.high,
  URGENCY_META.medium,
  URGENCY_META.low,
  URGENCY_META.none,
];

/** Вес для сортировки «по срочности» (меньше = выше). */
export function urgencyWeight(u: Urgency): number {
  return { urgent: 0, high: 1, medium: 2, low: 3, none: 4 }[u];
}
